import React from "react";

import styles from "./Paragraph.module.css";

type ParagraphProps = {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export function Paragraph({ children, className, ...rest }: ParagraphProps): React.JSX.Element {
  return (
    <p className={`${styles.paragraph} ${className}`} {...rest}>
      {children}
    </p>
  );
}
